import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { merchandisingShape, resolutionPropType } from "app/utils/propTypes";
import "./merchandising-switcher.scss";
import { FormattedMessage } from "react-intl";
import { sendTagOnMerchandisingSwitch } from "app/utils/analytics";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { RESOLUTION } from "app/constants";
import Swiper from "react-id-swiper";
import IconRight from "app/pages/.shared/static/icons/IconRight";
import IconLeft from "app/pages/.shared/static/icons/IconLeft";

class MerchandisingSwitcher extends React.PureComponent {
	constructor() {
		super();
		this.handleMerchClick = this.handleMerchClick.bind(this);
	}

	handleMerchClick(merchandising) {
		this.props.fetchMerchandising({
			code: merchandising.code,
		});
		sendTagOnMerchandisingSwitch(merchandising.code);
	}

	render() {
		const { merchandisings = [], currentMerchCode, resolution } = this.props;

		const currentMerchandising = merchandisings.find(merch => {
			return merch.code === currentMerchCode;
		});

		const merchandisingRest = merchandisings.filter(merch => {
			return merch.code !== currentMerchCode;
		});

		const merchList = [];

		const SLIDES_TO_SHOW = {
			[RESOLUTION.LARGE]: 4,
			[RESOLUTION.XLARGE]: 4,
			[RESOLUTION.MEDIUM]: 2.5,
			[RESOLUTION.SMALL]: 2.5,
		};

		const swiperParams = {
			navigation: {
				nextEl: ".merchandising-switcher__button--next svg",
				prevEl: ".merchandising-switcher__button--prev svg",
			},
			loop: true,
			slidesPerView: SLIDES_TO_SHOW[resolution],
			containerClass: "swiper-container merchandising-switcher",
			rebuildOnUpdate: true,

			renderPrevButton: () => {
				return (
					<div className="merchandising-switcher__button merchandising-switcher__button--prev">
						<IconLeft width={20} height={20} />
					</div>
				);
			},

			renderNextButton: () => (
				<div className="merchandising-switcher__button merchandising-switcher__button--next">
					<IconRight width={20} height={20} />
				</div>
			),
		};
		if (currentMerchandising) {
			merchList.push(currentMerchandising);
		}

		merchList.push({
			code: "ALL", // on met une valeur pour pas que ce soit selectionne si le currentMerchCode est vide
			label: <FormattedMessage id="merchandising.switcher.all.label" />,
		});

		return (
			<Swiper {...swiperParams}>
				{merchList.concat(merchandisingRest).map((merch, key) => {
					const itemClass = classNames({
						"merchandising-switcher__item": true,
						"merchandising-switcher__item--active": currentMerchCode === merch.code,
					});

					let to = {
						pathname: "/merch",
						search: `?code=${merch.code}`,
					};

					if (merch.code === "ALL") {
						to = {
							pathname: "/listing",
						};
					}
					return (
						<div key={key}>
							<RelativeLink
								className={itemClass}
								to={to}
								onClick={() => {
									this.handleMerchClick(merch);
								}}
							>
								{merch.label}
							</RelativeLink>
						</div>
					);
				})}
			</Swiper>
		);
	}
}

MerchandisingSwitcher.propTypes = {
	fetchMerchandising: PropTypes.func,
	merchandisings: PropTypes.arrayOf(merchandisingShape),
	currentMerchCode: PropTypes.string,
	resolution: resolutionPropType,
};

export default MerchandisingSwitcher;
